import Model from './Model';
import {PrintArea } from '@/models';
import ComponentVariation from './ComponentVariation';
import CustomizationTemplate from './CustomizationTemplate';

export default class Component extends Model {
  static type = 'components';

  name: string;
  code: string;
	configuration: any;
  printable: boolean;
  configurable: boolean;
  visible: boolean;
  price: number;
  warehouseItemArtifactId: number;
  printAreas: PrintArea[];
  componentVariations: ComponentVariation[];
  customizationTemplates: CustomizationTemplate[];
  defaultVariation: ComponentVariation;
  defaultTemplate: CustomizationTemplate;
  image?: any;
}
